// Missing kind on legacy docs is read as "packing".
export const categoryKind = (c) => c.kind ?? "packing";
// Is this category collapsed for this viewer? No entry (or no signed-in viewer) = expanded.
export const isCategoryCollapsed = (c, userId) => userId === undefined ? false : (c.collapsedBy[userId] ?? false);
//# sourceMappingURL=category.js.map